<template>
  <v-app>

    <!--
    <div v-if="isLog" class="flex d-flex justify-center align-center align-content-center">

      <v-progress-circular indeterminate color="blue" size="100" />

    </div>
    -->

    <core-filter v-if="isLog" />

    <!-- <core-toolbar v-if="isLog"/> -->

    <core-view />

    <core-drawer v-if="isLog"/>
  </v-app>
</template>
<script>

  import {eventBus} from "@/main";

  export default {
    name: "App",
    computed: {
      isLog() {
        return this.$store.state.isLogin
      },
    },
    created() {
      eventBus.$on("logout", () => {
        this.$router.push({path: '/'})
      });

    }
  }
</script>
<style lang="scss">
  @import '../src/styles/index.scss';

  /* Remove in 1.2 */
  .v-datatable thead th.column.sortable i {
    vertical-align: unset;
  }

  .v-label , .v-text-field__slot .v-label ,.v-input ,.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    font-size: 1.2rem;
  }

  .v-navigation-drawer .v-list .v-list-item {
    margin: 0px 0px 0 0 !important;
  }
</style>
